module.exports = __webpack_public_path__ + "img/podpis-zmluvy.33e3ca21.svg";